
import { createPinia } from 'pinia'
import piniaPluginPersist from 'pinia-plugin-persist'
export * from './modules/user'
const store = createPinia()
store.use(piniaPluginPersist)
export default store

// 全局注册 store
export function setupStore(app) {
    app.use(store);
}
export { store };

